module.exports = __webpack_public_path__ + "static/img/kh-5.74911e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-5.png
// module id = alKr
// module chunks = 4